/**
 * Environment utility functions
 */

export type Environment = 'production' | 'staging' | 'development' | 'sandbox'

/**
 * Get the current environment from NEXT_PUBLIC_SENTRY_ENVIRONMENT
 */
export const getCurrentEnvironment = (): Environment => {
  const env = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT as Environment
  return env || 'development'
}

/**
 * Check if the current environment allows bypass checks
 * ByPass is only allowed in non-production and non-sandbox environments
 * (i.e., staging and development)
 */
export const canBypassChecks = (): boolean => {
  const env = getCurrentEnvironment()
  return env !== 'production' && env !== 'sandbox'
}

/**
 * Check if the current environment is production
 */
export const isProduction = (): boolean => getCurrentEnvironment() === 'production'

/**
 * Check if the current environment is sandbox
 */
export const isSandbox = (): boolean => getCurrentEnvironment() === 'sandbox'

/**
 * Check if the current environment is staging
 */
export const isStaging = (): boolean => getCurrentEnvironment() === 'staging'

/**
 * Check if the current environment is development
 */
export const isDevelopment = (): boolean => getCurrentEnvironment() === 'development'

export const getWorkflowSigningKey = (): string => {
  const key = process.env.NEXT_PUBLIC_WORKFLOW_SIGNING_KEY
  if (!key) {
    throw new Error(
      '[NEXT_PUBLIC_WORKFLOW_SIGNING_KEY] was not set when this bundle was built, so requests '
      + 'cannot be signed. Pass it as a build argument and rebuild — setting it on the running '
      + 'container has no effect, because Next.js inlines NEXT_PUBLIC_* values at build time.',
    )
  }
  return key
}
